"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaBannerContent = void 0;
var _logger = require("@ori/logger");
var _presentationHooks = require("@ori/presentation-hooks");
var _context = require("../../../../context");
var _OrderOnBehalf = require("../../../OrderOnBehalf");
var _styles = require("../../styles");
var _BannersCarousel = require("../BannersCarousel");
var _TopAreaBannerDialog = require("../TopAreaBannerDialog");
var _jsxRuntime = require("react/jsx-runtime");
const TopAreaBannerContent = () => {
  const {
    isOrderOnBehalfVisible,
    bannersData = []
  } = (0, _context.useTopAreaBanner)();
  const {
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useDisclose)();
  if (isOrderOnBehalfVisible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      isOrderOnBehalfVisible: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OrderOnBehalf.OrderOnBehalf, {})
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BannersCarousel.BannersCarousel, {
      items: bannersData,
      onOpen: onOpen
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: "TopAreaBannerContent",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopAreaBannerDialog.TopAreaBannerDialog, {
        open: open,
        onClose: onClose
      })
    })]
  });
};
exports.TopAreaBannerContent = TopAreaBannerContent;